import Layout from '@/layout';
var taskDashBoardRouter = {
  path: '/taskDashBoard',
  component: Layout,
  redirect: '/taskDashBoard/list',
  name: 'TaskDashBoard',
  meta: {
    title: '',
    icon: 'mission'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/taskDashBoard/list');
    },
    name: 'List',
    meta: {
      title: '品宣宝支付数据看板',
      icon: 'mission'
    }
  }]
};
export default taskDashBoardRouter;